import { ECountry } from '@portals/help-center-core';
import { COUNTRY_COOKIE } from '@/_constants';

export const getCountry = async (): Promise<ECountry> => {
  // await import('next/headers') - чтобы иметь возможность вызвать getCountry не только в app папке
  const { cookies } = await import('next/headers');
  const cookieStore = cookies();
  const country = cookieStore.get(COUNTRY_COOKIE);

  return (country?.value as ECountry) || ECountry.RUSSIA;
};
